import Synths from '../primitives/Synths';
import Effects from '../primitives/Effects';

export default class SoundEngine {
  constructor (context) {
    this.context = context;
    this.osc = new Synths(this.context);
    this.fx = new Effects(this.context);
  }

  get now () { return this.context.currentTime; }
  get output () { return this.context.destination; }
}
